import React, {Component} from "react";
// import Input from "react-toolbox/lib/input/Input";
import PropTypes from "prop-types";
import LoadingStates from "../App.js";

class Invoices extends Component {

	constructor(props) {
		super(props);
		this.selectItem = props.selectable ? this.selectItem.bind(this) : null;
		this.selectAll = props.selectable ? this.selectAll.bind(this) : null;

		const defaultSelection = props.defaultSelectedItems ? props.defaultSelectedItems : [];
		const defaultTotal = defaultSelection.reduce((total, inv) => total + inv.receivable, 0.00);

		this.state = {
			selectedItems: defaultSelection,
			totalSelected: defaultTotal
		};
	}

	selectItem(item, selected) {
		var newItems;
		if (selected) {
			newItems = Array.from(this.state.selectedItems);
			newItems.push(item);
		} else {
			newItems = this.state.selectedItems.filter(invoice => invoice["id"] !== item["id"]);
		}
		this.setSelectedItems(newItems);
	}

	selectAll(event) {
		let selected = event.target.checked;
		let newItems = selected ? Array.from(this.props.invoices) : [];
		this.setSelectedItems(newItems);
	}

	setSelectedItems(selectedItems) {
		let total = selectedItems ?
			selectedItems.reduce((total, item) => total = total + item.receivable, 0) : 0.00;
		this.setState({
			selectedItems: selectedItems,
			totalSelected: total
		});
		if (this.props.onSelectedItemsChanged) {
			this.props.onSelectedItemsChanged([...selectedItems]);
		}
	}

	render() {
		let loadingState = this.props.loadingState;
		let invoices = this.props.invoices;
		let selectable = this.props.selectable;

		switch (loadingState) {
		case LoadingStates.inProgress:
			return (
				<div className="CustomerAccountInfo-Invoices">
					<h2>Loading Outstanding Invoices</h2>
				</div>
			);

		case LoadingStates.failed:
			return (
				<div className="CustomerAccountInfo-Invoices">
					<h2 className="loadingError">There was an error loading your outstanding invoices</h2>
				</div>
			);
		default:
			break;
		}

		if (invoices == null || invoices.length === 0) {
			return null;
		}

		let headerText = this.props.description;
		let totalLabel = "Total "+this.props.description;

		let totalString = this.props.invoices
			.reduce((total, invoice) => total = total+invoice.receivable, 0)
			.formatMoney();
		let totalSelected = this.state.totalSelected;
		let totalSelectedStr = totalSelected && (totalSelected > 0.00) ? totalSelected.formatMoney() : "";

		const allChecked = this.props.invoices.length === this.state.selectedItems.length;
		let checkHeader = selectable ?
			<th className="money checkColumn">Pay 
				<input type="checkbox" checked={allChecked} onChange={this.selectAll}/></th> : null;
		let checkTotal = selectable ?
			<th className="money checkColumn">{totalSelectedStr}</th> : null;
		let totalSpan = 6; //selectable ? 7 : 6;
		return (
			<div className="CustomerAccountInfo-Invoices">
				<h2>{headerText}</h2>
				<table>
					<thead>
						<tr>
							<th>Invoice</th>
							<th>Date</th>
							<th>Description</th>
							<th>Ad</th>
							<th>Due Date</th>
							<th className="money">Charge</th>
							<th className="money">Amt. Due</th>
							{checkHeader}
						</tr>
					</thead>
					<tbody>
						{invoices.map(invoice => {
							let selected = this.state.selectedItems ?
								this.state.selectedItems
									.findIndex(inv => inv.id === invoice.id) >= 0 : false;
							return (
								<Invoice
									key={invoice.id}
									invoice={invoice}
									selected={selected}
									selectAction={this.selectItem}
								/>
							);
						})}
					</tbody>
					<tfoot>
						<tr>
							<th className="money" colSpan={totalSpan}>{totalLabel}</th>
							<th className="money">{totalString}</th>
							{checkTotal}
						</tr>
					</tfoot>
				</table>
			</div>
		);
	}
}

Invoices.propTypes = {
	loadingState: PropTypes.number,
	invoiceTableType: PropTypes.number,
	invoices: PropTypes.array,
	description: PropTypes.string,
	selectable: PropTypes.bool,
	onSelectedItemsChanged: PropTypes.func,
	defaultSelectedItems: PropTypes.array
};

function Invoice(props) {
	let selectable = props.selectAction != null;
	let transDate = props.invoice.transDate.toLocaleDateString();
	let dueDate = props.invoice.dueDate.toLocaleDateString();
	let amount = props.invoice.amount.formatMoney();
	let amtDue = props.invoice.receivable.formatMoney();
	let checkbox = selectable ?
		<td className="money">
			<input
				type="checkbox"
				checked={props.selected}
				onChange={(event) =>
					props.selectAction(props.invoice, event.target.checked)
				}/>
		</td> : null;
	return (
		<tr>
			<td>{props.invoice.id}</td>
			<td>{transDate}</td>
			<td>{props.invoice.description}</td>
			<td>{props.invoice.adId}</td>
			<td>{dueDate}</td>
			<td className="money">{amount}</td>
			<td className="money">{amtDue}</td>
			{checkbox}
		</tr>
	);
}

Invoice.propTypes = {
	invoice: PropTypes.object,
	selected: PropTypes.bool,
	selectAction: PropTypes.func
};

export default Invoices;



// WEBPACK FOOTER //
// ./src/components/Invoices.js